<template>
  <div>
    <div class="wpcm-custm-amt-before-title">
      <slot name="before_title"></slot>
      <h3 v-if="title" class="wpcm-custm-amt-title">{{ title }}</h3>
    </div>
    <div class="wpcm-custom-amt-box-container">
      <slot name="before_box"></slot>
      <div class="wpcm-custm-amt-box" v-if="custom_amount">
        <span v-if="symbol" class="wpcm-symbl-prefix">{{ getSymbol() }}</span>
        <input :value="amount" @input="updateAmount($event.target.value)" @keypress="isNumber($event)"
          :placeholder="strings ? strings.donation_amount : 'Enter The Amount You Want'" />
        <slot name="in_box"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
const { mapState, mapMutations } = window.Vuex;

export default {
  props: ["custom_amount", "title", "symbol", "symbols", "strings", "display_amount", "min_donation_amount", "max_donation_amount","post_type"],
  computed: {
    ...mapState(["amount", "amount_recurring", "currency", "recurring"]),
  },
  watch: {
    amount: function (val) {
      if (this.post_type === 'cause') {
        
        if (val > this.max_donation_amount) {
          this.$notify({
            title: "Amount",
            message: `Amount should be less than ${this.max_donation_amount}`,
            type: "error",
          });

          this.$store.commit("setValue", { key: "amount", val: this.max_donation_amount });
        }
        if (val < this.min_donation_amount) {
          this.$notify({
            title: "Amount",
            message: `Amount should be greater than ${this.min_donation_amount}`,
            type: "error",
          });

          this.$store.commit("setValue", { key: "amount", val: this.min_donation_amount });
        }
      }
    },
  },
  methods: {
    updateAmount(value) {
      const key = "amount";
      this.$store.commit("setValue", { key, val: value });
    },
    getSymbol() {
      return this.symbols[this.currency] !== undefined
        ? this.symbols[this.currency]
        : this.symbol;
    },
    isNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which || evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
    },
  },
};
</script>
